import { Outlet } from "react-router-dom";

const FeeSchedulePageLayout = () => {
  return (
    <><Outlet /></>
  );
};

export default FeeSchedulePageLayout;